<template>
  <!-- eslint-disable  -->
  <form class="px-3 py-4 add-product-modal" v-on:submit.prevent="submitAddProduct" action="self">
    <p>Please select a product to add to this quote. Adding a product will change this quote into a bundle. You can still bind a single product when this quote is a bundle if desired.</p>
    <div class="px-3 py-2" v-if="formErrors.general">
      <div class="alert alert-danger" role="alert">
        {{ formErrors.general }}
      </div>
    </div>
    <div class="inner-div px-3 pt-8 pb-4">
      <div class="selected-product-row pb-2">
        <label>Selected Product</label><br/>
        <span class="product-name" :class="`${productName}`">{{ productName }}</span>
      </div>
      <hr />
      <div class="pt-2" :class="((productName=='Home' || productName=='Condo' || productName=='Renters') ? 'btn100' : 'btnsplit')">
       <input-product-type :insuranceType="formFields.insuranceType"></input-product-type>
      </div>
    </div>
    <!-- CONFIRM & CONSENT NOTICE -->
    <button type="submit" id="add-product-submit-button"
      class="btn btn-primary d-block mx-auto">Add Product</button>
  </form>
</template>

<script>
/* eslint-disable */
import QRP from '../../../config/QRP.env';
import filters from '../../../config/admin/filters';
import InputProductType from '../interactive/InputProductType';
import postData from '../../services/postData';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['productName'],
  data() {
    return {
      formFields: {
        insuranceType: {
          field_name: 'insurance_type',
          label: 'Add Product',
          field_value: '',
          rules: [],
          field_type: 'text',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false
        },
      },        
      formErrors: [],
    };
  },
  components: {
    InputProductType,
  },
  created() {
  },
  mounted() {
    const forceBindSubmitButton = document.getElementById('add-product-submit-button');
    forceBindSubmitButton.disabled = true;
    let productAccess = JSON.parse(sessionStorage.getItem('productAccess'));
    const productOrder = [1, 21, 18, 12];
    //Added logic to hide product if flow is bind for that product
    if (productAccess.includes(QRP.PRODUCTS.AUTO) && this.productName === 'Auto') { 
      const index = productAccess.indexOf(QRP.PRODUCTS.AUTO);
      if (index > -1) {
        productAccess.splice(index, 1);
      }
    } else if ((productAccess.includes(QRP.PRODUCTS.HOME) && this.productName === 'Home') || (productAccess.includes(QRP.PRODUCTS.CONDO) && this.productName === 'Condo') || (productAccess.includes(QRP.PRODUCTS.RENTERS) && this.productName === 'Renters')) {
      let index = productAccess.indexOf(QRP.PRODUCTS.HOME);
      if (index > -1) {
        productAccess.splice(index, 1);
      }
      let cindex = productAccess.indexOf(QRP.PRODUCTS.CONDO);
      if (cindex > -1) {
        productAccess.splice(cindex, 1);
      }
      let rindex = productAccess.indexOf(QRP.PRODUCTS.RENTERS);
      if (rindex > -1) {
        productAccess.splice(rindex, 1);
      }
    }
    this.productButtonsData = Object.create(this.formFields.insuranceType);
    if (typeof productAccess === 'object') {
      for (let i = 0; i < productOrder.length; i += 1) {
        if (productAccess.includes(productOrder[i])) {
          this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
        }
      }
    } else {
      const productAccessArray = productAccess.split(',');

      for (let i = 0; i < productOrder.length; i += 1) {
        if (productAccessArray.includes(productOrder[i])) {
          this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
        }
      }
    }

    this.formFields.insuranceType = [];
    this.formFields.insuranceType = this.productButtonsData;
  },
  computed: {
  },
  methods: {
    submitAddProduct() {
      this.$validator.detach(this.formFields.insuranceType.field_name);
      this.$validator.attach({
        name: this.formFields.insuranceType.field_name,
        rules: 'required',
        getter: () => this.formFields.insuranceType.field_value,
      });
      this.$validator.validate(this.formFields.insuranceType.field_name).then(async (result) => {
        if (!result) {
          if (this.errors.has(this.formFields.insuranceType.field_name)) {
            if (this.productName === 'Auto') {
              document.getElementById('Home').focus();
            } else {
              document.getElementById('Auto').focus();
            }
          }
          return;
        }
        const forceBindSubmitButton = document.getElementById('add-product-submit-button');
        forceBindSubmitButton.disabled = true;

        let session_id = JSON.parse(sessionStorage.getItem('sessionData')).SessionId;
        let SrcProductTypeID = parseInt(sessionStorage.getItem('flowType'));
        const requestBody = {
          'SrcSessionId' : session_id,
          'SrcProductTypeID' : SrcProductTypeID,
          'ProductTypeId' : this.formFields.insuranceType.field_value
        }
        this.callAddProduct(requestBody);
      });
    },
    async callAddProduct(requestBody) {
      let bindResponse = {};
      const url = '/autoquotes/addProduct';
      await postData.submitPostRequest(url, requestBody).then(async (response) => {
        if (response) {
          let item = response.data;
          sessionStorage.setItem('selectedQuote', JSON.stringify(item));
          let flowType = this.getFlowType(item);
          sessionStorage.setItem('flowType', flowType);
          let sessionData = JSON.parse(sessionStorage.getItem('selectedQuote'));
          let HOQuoteId,newRoute,cuurentNav;
          for (let i = 0; i < item.QuoteBundle.details.length; i += 1) {
            sessionData.ProductTypeId = item.QuoteBundle.details[i].productTypeId;
            sessionData.SessionId = item.QuoteBundle.details[i].quoteId;
            if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.AUTO) {
              sessionStorage.setItem('autoSessionData', JSON.stringify(sessionData));
            } else {
              if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.HOME) {              
                sessionStorage.setItem('homeSessionData', JSON.stringify(sessionData));
                HOQuoteId = item.QuoteBundle.details[i].quoteId;          
                newRoute = '/home/name-insured';
                cuurentNav  = '/pages/honamedinsured/' + HOQuoteId;
              } else if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.CONDO) {
                sessionStorage.setItem('condoSessionData', JSON.stringify(sessionData));
                HOQuoteId = item.QuoteBundle.details[i].quoteId;
                newRoute = '/condo/name-insured';
                cuurentNav  = '/pages/conamedinsured/' + HOQuoteId;
              } else if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.RENTERS) {
                sessionStorage.setItem('renterSessionData', JSON.stringify(sessionData));
                HOQuoteId = item.QuoteBundle.details[i].quoteId;
                newRoute = '/renters/name-insured';
                cuurentNav  = '/pages/renamedinsured/' + HOQuoteId;
              }
            }
          }
          this.$store.dispatch('setSessionQuote', { SessionId: HOQuoteId });
          this.$store.dispatch('setCurrentNav', cuurentNav);
          let curRoute = this.$router.currentRoute.path;
          if (curRoute.includes(newRoute)) {
            let timeStamp = new Date().getTime();
            this.$router.push({
              path: newRoute + '?' + timeStamp
            })
          } else {
            this.$router.replace(newRoute);
          }
        }
      }).catch((error) => {
        const forceBindSubmitButton = document.getElementById('add-product-submit-button');
        this.formErrors.general = error.response.data.Message;
        forceBindSubmitButton.disabled = false;
      });
      return bindResponse;
    },    
    getFlowType(cItem) {
      let productTypeID = 0;
      if (cItem.QuoteBundle && cItem.QuoteBundle.details) {
        for (let i = 0; i < cItem.QuoteBundle.details.length; i += 1) {
          if (cItem.QuoteBundle.details[i].productTypeId !== QRP.PRODUCTS.AUTO) {
            if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.HOME) {
              productTypeID = 'bundle';
            } else if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.CONDO) {
              productTypeID = 'cabundle';
            } else if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.RENTERS) {
              productTypeID = 'rabundle';
            }
          }
        }
      }
      return productTypeID;
    },
  },
  watch: {
    'formFields.insuranceType.field_value': function () {
      this.formErrors = [];
      const forceBindSubmitButton = document.getElementById('add-product-submit-button');
      if (this.formFields.insuranceType.field_value !== '') {
        forceBindSubmitButton.disabled = false;
      } else {
        forceBindSubmitButton.disabled = true;
      }
    },
  },
};
</script>
<style lang="scss">
.add-product-modal p{
  font-size:12px;
}
.selected-product-row label{
  font-size:12px;
  font-weight: 600;
  color:#333333;
}
.product-name {
  padding:4px 24px 4px 24px;
  border-radius:100px;
  font-size:12px;
  font-weight:400;
  &.Auto {
    background-color: #DCDFE7;
    color: #2D374C;
  }
  &.Home {
    background-color: #DBE5E5;
    color: #314D4D;
  }
  &.Condo {
    background-color: #E6E0E7;
    color: #423545;
  }
  &.Renters {
    background-color: #ECE1CF;
    color: #603F0B;
  }
}

.btn100 .switch-box-type{
  width:100% !important;
}
.btnsplit .switch-box-type{
  width:33.33% !important;
}
.add-product-modal .form-group .text-danger {
  color: #BB0000 !important;
  background-color: transparent !important;
  padding: 0;
}
#add-product-submit-button.btn-primary {
  
  border-radius: 4px;
  background-color: #FFFFFF;
  color: #003366;
  border-color: #003366;

  &:focus, &:hover  {
    background-color: #003366 !important;
    color: #FFFFFF !important;
    box-shadow: none !important;
  }

  &:disabled {
    background-color: #949494;
    color: #FFF;
    border-color: #949494;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/AddProductModal.vue?229d6d58